export const adminProductId = '612358238b17d4e686036d56';
export const webEditorUsageFeatureCode = 'WUC';

export const paginationPageSize = 20;
export const paginationMaxPages = 10;

export const disabledState = "disabled";
export const focusedState = "focused";
export const normalState = "normal";

export const screenState = {
    splitScreen: 'splitScreen',
    singleScreen: 'singleScreen',
}

export const previewType = {
    pdf: 'pdf',
    html: 'html',
}

export const enableTextLibraryAutoComplete = true;

export const previewPdfLinkId = "previewPdfLinkId";
export const previewHtmlLinkId = "previewHtmlLinkId";
export const localPrintViewpointPdfLinkId = "localPrintViewpointPdfLinkId";
export const localPrintDynamoPdfLinkId = "localPrintDynamoPdfLinkId";

export const menuState = {
    edit: 'edit',
    attachment: 'attachment',
}

export const sideBarState = {
    closed: 'closed',
    predefinedTexts: 'predefinedTexts',
    textLibrary: 'textLibrary',
}

export const distribution = {
    notSet: 'CentralDistribution',
    print: 'Print',
    kivra: 'Kivra',
    digipost: 'Digipost',
    localPrint: 'LocalPrint',
    email: 'Email',
    archiving: 'Archiving',
}

export const distributionArchiveMethod = {
    viewpoint: 'Viewpoint',
    onprem: 'Onprem',
}

export const fileStatus = {
    draft: 'Draft',
    ok: 'OK',
    discarded: 'Discarded',
    deleted: 'Deleted',
}

export const editorType = {
    undefined: 'Undefined',
    file: 'File',
    root: 'Root',
    fontDef: 'FontDef',
    colorDef: 'ColorDef',
    tableDef: 'TableDef',
    imageDef: 'ImageDef',
    formDef: 'FormDef',
    doc: 'Doc',
    index: 'Index',
    page: 'Page',
    text: 'Text',
    table: 'Table',
    textChoice: 'TextChoice',
    textPart: 'TextPart',
    font: 'Font',
    textColor: 'TextColor',
    paragraphProperties: 'ParagraphProperties',
    paragraph: 'Paragraph',
    tabset: 'Tabset',
    run: 'Run',
    inputField: 'InputField',
    hyperLink: 'HyperLink',
    mL: 'ML',
    nL: 'NL',
    keep: 'Keep',
    list: 'List',
    listItem: 'ListItem',
    writeEnable: 'WriteEnable',
    image: 'Image',
    insertPoint: 'InsertPoint',
    tableColGroup: 'TableColGroup',
    tableCol: 'TableCol',
    tableColumn: 'TableColumn',
    tableRow: 'TableRow',
    heightSpace: 'HeightSpace',
    svg: 'Svg',
    svgLine: 'SvgLine',
    svgRectangle: 'SvgRectangle',
    svgPath: 'SvgPath',
    svgImage: 'SvgImage',
    svgText: 'SvgText',
    breakTable: 'BreakTable',
    breakTableFirstHeader: 'BreakTableFirstHeader',
    breakTableRunningHeader: 'BreakTableRunningHeader',
    breakTableLastFooter: 'BreakTableLastFooter',
    breakTableRunningFooter: 'BreakTableRunningFooter',
    breakTableBody: 'BreakTableBody',
    autoDate: 'AutoDate',
}

export const inputFieldType = {
    text: 'Text',
    integer: 'Integer',
    decimal: 'Decimal',
    checkbox: 'Checkbox',
    select: 'Select',
    date: 'Date',
}

export const copyState = {
    inactive: 0,
    active: 1,
    expired: 2,
}

export const formatButtonState = {
    disabledAndUnfocused: 0,
    disabledAndFocused: 1,
    enabledAndUnfocused: 2,
    enabledAndFocused: 3,
}

export const auditEventLogType = {
    openDocument: 0,
}

export const quillFormatKeywords = {
    bold: 'bold',
    italic: 'italic',
    underline: 'underline',
    align: 'align',
    alignLeft: 'left',
    alignRight: 'right',
    alignCenter: 'center',
    alignJustify: 'justify',
    list: 'list',
    bullet: 'bullet',
    ordered: 'ordered',
    fontSize: 'fs',
    fontfamily: 'fontfamily',
    color: 'color',
    bgColor: 'bgcolor',
    textIndent: 'textIndent',
    paddingleft: 'paddingleft',
    paddingright: 'paddingright',
    paddingtop: 'paddingtop',
    paddingbottom: 'paddingbottom',
    margnleft: 'margnleft',
    undo: 'undo',
    redo: 'redo',
}

export const quillApiSource = {
    user: 'user',
    api: 'api',
    silent: 'silent',
}

export const attachmentActionType = {
    none: 'None',
    createOrUpdate: 'CreateOrUpdate',
    delete: 'Delete',
}

export const textLibrarySearchKeywords = '#?';

export const dxmlDocumentContainerId = 'dxmlDocumentContainerId';

export const errors = {
    failLoadDxmlFile: '(500) Failed to load dxml file',
    failSaveDocument: '(501) Failed to save document',
    failLoadFile: '(502) Failed to load file',
    failLoadData: '(503) Failed to load data',
    failSearch: '(504) Failed to search',
    failSearchAttachment: '(505) Failed to search attachment',
    failLoadFileExtension: '(506) Failed to load file because file extension ${extension} is not supported.',
    disableDistributionError: '(507) It can not publish document. Please disable distribution in the WebEditor settings in the CenterPoint.',
    enableDistributionError: '(508) It can not publish document. Please enable distribution in the WebEditor settings in the CenterPoint.',
}

export const textLibraryValueType = {
    plainText: 0,
    html: 1,
}

export const fontSizes = ['6', '7', '8', '9', '10', '10.5', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '24', '28', '32', '36', '40', '44', '48'];

export const autoDate = {
    htmlAttribute: 'auto-date-format',
    quillEmbedBlotName: 'autoDate',
    quillEmbedTagName: 'SPAN',
    quillEmbedClassName: 'ql-auto-date',
}

export const distributionListsStatus = {
    active: "Active",
    disabled: "Disabled",
    deleted: "Deleted"
}